import { render, staticRenderFns } from "./RecentSearchTable.vue?vue&type=template&id=5105ec8c"
import script from "./RecentSearchTable.vue?vue&type=script&lang=js"
export * from "./RecentSearchTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports